// extracted by css-extract-rspack-plugin
export default {"root":"_52afc881"};